import { PaginateSpots, Spot2, SpotAssets } from '~/models/Spot'
import { BaseRepository } from '../baseRepository'
import { ApiSpot, ApiSpotAsset } from './apiTypes'
import { SpotEntityMapper } from './entityMapper'
import Media from '~/models/Media'
import { MediaEntityMapper } from '~/passporter-services/media/entityMapper'
import { ApiMedia } from '~/passporter-services/media/apitype'
import { ApiPage, toPage } from '~/passporter-services/shared/pagination'
import { Page } from '~/models/PaginatedItems'

export class SpotRepository extends BaseRepository {
	private static resource = 'v1/spots'

	static async find(placeId: string): Promise<Spot2> {
		const response: ApiSpot = await this.get(`${this.resource}/find/`, {
			place_id: placeId,
		})
		return SpotEntityMapper.toSpot(response)
	}

	static async getMedias(id: string, page: number, pageSize: number): Promise<Page<Media>> {
		const params: any = { page, page_size: pageSize }
		const response: ApiPage<ApiMedia> = await this.get(`${this.resource}/${id}/medias/`, params)
		const medias = MediaEntityMapper.toMedias(response.results)
		return toPage(response, medias)
	}

	static async getSpot(id: string): Promise<Spot2> {
		const response: ApiSpot = await this.get(`${this.resource}/${id}`)
		return SpotEntityMapper.toSpot(response)
	}

	static async createSpotFromPlace(placeId: string): Promise<Spot2> {
		const response: ApiSpot | undefined = await this.post(`${this.resource}/save/place/${placeId}/`)
		return SpotEntityMapper.toSpot(response!)
	}

	static async getAssets(id: string): Promise<SpotAssets> {
		const response: ApiSpotAsset[] = await this.get(`${this.resource}/${id}/assets/`)
		return SpotEntityMapper.toAssets(response)
	}

	static async getNearbySpots(
		latitude: number,
		longitude: number,
		radius: number,
		page: number,
		pageSize: number
	): Promise<PaginateSpots> {
		const params = { latitude, longitude, radius, page, page_size: pageSize }
		const response: any = await this.get(`${this.resource}/search/`, params)
		return SpotEntityMapper.toPaginatedSpots(response)
	}
}
